import axios from "axios";

const QUALITYTEST_API_BASE_URL=window.API_URL + "database";


    export const getDbTablesAndColumns = async (idWorkspace) => {
        return await axios.get(QUALITYTEST_API_BASE_URL+"/"+idWorkspace);
    }

   